import { render, staticRenderFns } from "./OwnersDetailsTable.vue?vue&type=template&id=5f117786&"
import script from "./OwnersDetailsTable.vue?vue&type=script&lang=js&"
export * from "./OwnersDetailsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports